import { useTranslation } from "react-i18next";
import { App, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import { useUpdateSurveyAssignmentMutation } from "../../../../redux/service.js";
import BaseModal from "../../../../components_v2/Modal/BaseModal.js";
import BaseButton from "../../../../components_v2/Button/BaseButton.js";
import BaseSpinner from "../../../../components_v2/Spiner/BaseSpinner.js";
import { BUTTON_VARIANTS } from "@/components_v2/Button/constants.js";

const SubmissionConfirmationModal = ({ open, onCancel, survey }) => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const navigate = useNavigate();

  const [submitSurvey, submitSurveyResponse] =
    useUpdateSurveyAssignmentMutation();

  const handleSubmitSurvey = () => {
    submitSurvey({
      id: survey.details.id,
      data: { isSubmitted: true },
    })
      .unwrap()
      .then(() => {
        navigate(`/reports/${survey.details.id}/submission-success`);
      })
      .catch((error) =>
        notification.error({ message: error.data.errors[0].detail }),
      )
      .finally(onCancel);
  };

  return (
    <BaseModal
      open={open}
      title={t("confirmSubmission")}
      onCancel={onCancel}
      footer={
        <Flex wrap justify="end" align="center" gap={"small"}>
          <BaseButton
            key="cancel"
            variant={BUTTON_VARIANTS.TERTIARY}
            onClick={onCancel}
          >
            {t("buttons.cancel")}
          </BaseButton>

          <BaseButton
            key="confirm"
            onClick={handleSubmitSurvey}
            disabled={submitSurveyResponse.isLoading}
          >
            {submitSurveyResponse.isLoading && <BaseSpinner size="small" />}{" "}
            {t("buttons.submitReport")}
          </BaseButton>
        </Flex>
      }
    >
      {submitSurveyResponse.isLoading
        ? t("reportIsBeingSubmitted")
        : t("submitConfirmation")}
    </BaseModal>
  );
};

SubmissionConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  survey: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default SubmissionConfirmationModal;
